import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DOOD_API } from '@config/ws.config';
import { DoodProductModel } from '@core/models/product.model';

export type Suggestion = {
  data: DoodProductModel;
  type: 'product';
};

@Injectable({
  providedIn: 'root',
})
export class SuggestionsSetsApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public getSuggestionsSet$(suggestionsSetId: string, context: any): Observable<Suggestion[]> {
    return this.httpClient.post<Suggestion[]>(
      `${DOOD_API}/suggestions-sets/${suggestionsSetId}/suggest`,
      context,
    );
  }
}
